module.exports = __webpack_public_path__ + "img/CDF.b36f3117.gif";